import { render, staticRenderFns } from "./ResumenCompra.vue?vue&type=template&id=7827e59a"
import script from "./ResumenCompra.vue?vue&type=script&lang=js"
export * from "./ResumenCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports